import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import { useHistory } from 'react-router-dom';

    const Assets = () => {
        const history = useHistory()

        toastr.options = TOAST_OPTIONS;

        const [modal_users, setmodal_users] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [assetList, setAssetList] = useState([]);
        const [regions, setRegions] = useState([])
        const [clusters, setClusters] = useState([])
        const [areas, setAreas] = useState([])
        const [schemes, setSchemes] = useState([])
        const [types, setTypes] = useState([])
        const [categories, setCategories] = useState([])
        const [statusOptions, setStatusOptions] = useState(['Active','Not Functional','Decommissioned'])
        const [conditionOptions, setConditionOptions] = useState(['Excellent','Good','Fair','Poor','Very Poor'])
        const [isloading, setIsloading] = useState(false)

        const [sRegion, setSRegion] = useState('')
        const [sCluster, setSCluster] = useState('')
        const [sArea, setSArea] = useState('')
        const [sScheme, setSScheme] = useState('')
        const [sType, setSType] = useState('')
        const [sCategory, setSCategory] = useState('')
        const [sStatus, setSStatus] = useState('')
        const [sCondition, setSCondition] = useState('')

        const handleClearSearch = () =>{
          setSRegion('')
          setSCluster('');
          setSArea('')
          setSScheme('')
          setSType('')
          setSCategory('')
          setSStatus('')
          setSCondition('')
          fetchData()
        }
        const fetchData = () => {
          handleFilterData()
          axios.get(url.REGIONS, Config).then((r)=>{ setRegions(r.data)}).catch((e)=>console.log(e))
          axios.get(url.CLUSTERS, Config).then((r)=>{ setClusters(r.data)}).catch((e)=>console.log(e))
          axios.get(url.AREAS, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>console.log(e))
          axios.get(url.SCHEME, Config).then((r)=>{ setSchemes(r.data) }).catch((e)=>console.log(e))
          axios.get(url.ASSETCATEGORIES, Config).then((r)=>{ setCategories(r.data) }).catch((e)=>console.log(e))
          axios.get(url.ASSETTYPES, Config).then((r)=>{ setTypes(r.data) }).catch((e)=>console.log(e))
        }
        const handleRegionChange = (rid) =>{

        }
        const handleClusterChange = (cid) =>{
            
        }
        const handleAreaChange = (aid) =>{
            
        }
        const handleFilterData = () =>{
            setIsloading(true)
            const data = {
              id          :"",
              regionId    :sRegion,
              clusterId   :sCluster,
              areaId      :sArea,
              schemeId    :sScheme,
              categoryId  :sCategory,
              typeId      :sType, 
              parentId    :"",
              status      : sStatus,
              condition   :sCondition
            }
            axios.post(url.ASSETSFILTER, JSON.stringify(data), Config).then((r)=>{ 
              //setAssetList(r.data);
              console.log(r)
              setIsloading(false) 
            }).catch((e)=>{  
              console.log(e); 
              setIsloading(false) 
            });
        }
        useEffect(() => {
         fetchData();
        },[]);

        
        const { SearchBar } = Search;
        const columns = [

        {
          dataField: 'name',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'title',
          text: 'Title',
          sort: true
        },
        {
          dataField: 'deptName',
          text: 'Department',
          sort: true
        },
        /*{
          dataField: 'email',
          text: 'Email',
          sort: true
        },*/
        {
            dataField: 'lastLogin',
            text: 'Last Login',
            sort: true
          },
          {
            dataField: 'status',
            text: '',
            sort: true,
            formatter: statusFormatter
          },
        {
          dataField: "",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'id',
          order: 'asc'
        }];
        function statusFormatter(cellContent, row) {
          if (row.status == "Active") {
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function actionFormatter(cellContent, row){
          return(
            <>
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  //onClick={() => { handleClickEdit(row); }}
                >
                  Details
            </Button>
          </>
          )
        }

        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Assets | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.COMPANY} breadcrumbItem="Assets" />


                        <Row>


                            <Col lg="12">
                          
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                
                  
                                

                                <Row className="justify-content-center mb-1">
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Region</label>
                                            <select className="form-select form-select-sm" value={sRegion} onChange={(e)=>{setSRegion(e.target.value); handleRegionChange(e.target.value)}}>
                                            <option>All</option>
                                            {regions.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.region}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Cluster</label>
                                            <select className="form-select form-select-sm" value={sCluster} onChange={(e)=>{setSCluster(e.target.value); handleClusterChange(e.target.value)}}>
                                            <option>All</option>
                                            {clusters.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.cluster}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Area</label>
                                            <select className="form-select form-select-sm" value={sArea} onChange={(e)=>{setSArea(e.target.value); handleAreaChange(e.target.value)}}>
                                            <option>All</option>
                                            {areas.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.name}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Scheme</label>
                                            <select className="form-select form-select-sm" value={sScheme} onChange={(e)=>setSScheme(e.target.value)}>
                                            <option>All</option>
                                            {schemes.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.scheme}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                   
                                </Row>
                                <Row  className="justify-content-center mb-2 ">
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Category</label>
                                            <select className="form-select form-select-sm" value={sCategory} onChange={(e)=>setSCategory(e.target.value)}>
                                            <option>All</option>
                                            {categories.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.category}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Type</label>
                                            <select className="form-select form-select-sm" value={sType} onChange={(e)=>setSType(e.target.value)}>
                                            <option>All</option>
                                            {types.map((r,k)=>(
                                                <option value={r.id} key={k}>{r.type}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                            <option>All</option>
                                            {statusOptions.map((r,k)=>(
                                                <option value={r} key={k}>{r}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xl={3}>
                                        <div className="mb-3">
                                            <label>Condition</label>
                                            <select className="form-select form-select-sm" value={sCondition} onChange={(e)=>setSCondition(e.target.value)}>
                                            <option>All</option>
                                            {conditionOptions.map((r,k)=>(
                                                <option value={r} key={k}>{r}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Col>
                                </Row>
                                <Row  className="justify-content-center mb-2 mt-3">
                                <Col lg={3}> 
                                    <div className="d-grid gap-2">
                                        <Button
                                        color='primary'
                                        className="btn btn-sm"
                                        onClick={()=>{handleFilterData()}}
                                        >
                                        <i className="mdi mdi-magnify me-1" />
                                        Search
                                        </Button>
                                    </div>
                                    </Col>
                                    <Col lg={3}> 
                                    <div className="d-grid gap-2">
                                        <Button
                                        color='warning'
                                        className="btn btn-sm"
                                        //onClick={()=>{handleClearSearch()}}
                                        >
                                        <i className="mdi mdi-notification-clear-all me-1" />
                                        Reset search
                                        </Button>
                                    </div>
                                    </Col>
                                    <Col lg={3}> 
                                    <div className="d-grid gap-2">
                                        <Button
                                        color='success'
                                        className="btn btn-sm"
                                        onClick={()=>{ history.push('/Add-Asset') }}
                                        >
                                        <i className="mdi mdi-plus me-1" />
                                        Add Asset
                                        </Button>
                                    </div>
                                    </Col>
                                    
                                </Row>
                                </CardBody>
                                </Card>
        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Assets ({assetList.length})</h5>
                                <CardBody>

                                
                                
                                {assetList && (assetList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="id"
                                      data={ assetList }
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={ assetList } 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {assetList && (assetList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No Asset Found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default Assets;